export enum SideOrderAbbreviationE {
  COURSE_AS_SIDE_ORDER = `CASO`,
  POSSIBLE_SIDE_ORDER = 'PSO',
}

export type SideOrderAbbreviationT = `${SideOrderAbbreviationE}-${number}`;
export type SideOrderRedirectT = Record<SideOrderAbbreviationT, number>;

export type MappedSideOrdersRedirectT = Record<string, SideOrderRedirectT>;
